import { Component } from '@angular/core';
import { CellRendererComponent } from '@valg-shared/components/table/directives/cell-component-outlet/cell-component-outlet.directive';
import { getValueAt } from "@valg-shared/utils/object-utils";
import { Column } from '@valg-shared/components/table/table/column';
import { camelToSnakeCase } from '@valg-shared/utils/string-utils';
import { MapAreaStyle } from '@shared/components/map/map-styles.model';
@Component({
  selector: 'valg-dk-color-status-renderer',
  templateUrl: './color-status-renderer.component.html',
  styleUrls: [ './color-status-renderer.component.scss' ]
})
export class ColorStatusRendererComponent implements CellRendererComponent {
  value: MapAreaStyle = MapAreaStyle.NoData;
  text = "";
  color = "";

  public init(data: unknown, column: Column): void {
    this.value = getValueAt(data, column.path);
    this.text = 'enums.'+camelToSnakeCase('MapAreaStyle')+'.'+camelToSnakeCase(this.value);
    this.color = '--map-color-'+camelToSnakeCase(this.value);
  }

}

